export const inclusionQueryKeys = {
  all: ['cruise-inclusions'] as const,
  filters: (inclusionId: string) => [...inclusionQueryKeys.all, 'filters', inclusionId] as const,
};
